import Markdown from 'components/commercetools-ui/organisms/markdown';
import { isStringHtml } from 'helpers/utils/isStringHtml';
import React, { memo } from 'react';

export interface Stat {
  stat: string;
  description: string;
}

export interface StatsProps {
  stats: Stat[];
  bgColor: string;
  sectionId?: string;
}

const Stats: React.FC<StatsProps> = ({ stats, bgColor, sectionId }) => {
  const columnClass = `grid-cols-${Math.min(4, stats.length)}`;
  const classNameMain = `bg-${bgColor} pb-32 pt-32 lg:pt-64 lg:pb-64`;

  return (
    <div className={classNameMain} id={sectionId} data-id="stats-section">
      <div className="mx-auto max-w-7xl px-24 lg:px-32" data-id="stats-container">
        <dl className={`grid-cols-1 text-center lg:grid lg:gap-x-34 ${columnClass}`} data-id="stats-list">
          {stats.map((stat, index) => (
            <div key={stat.stat} className="mb-40 flex flex-col last:mb-0 lg:mb-0" data-id={`stat-item-${index}`}>
              <dt className="text-3xl font-semibold" data-id={`stat-value-${index}`}>
                {stat.stat}
              </dt>
              <dd className="mt-4 flex flex-auto flex-col text-base leading-6" data-id={`stat-description-${index}`}>
                <div className="prose max-w-none text-padi-gray-darker" data-id={`stat-content-${index}`}>
                  {isStringHtml(stat.description) ? (
                    <div
                      className="first:mt-0"
                      dangerouslySetInnerHTML={{ __html: stat.description }}
                      data-id={`stat-html-${index}`}
                    />
                  ) : (
                    <Markdown className="first:mt-0" markdown={stat.description} />
                  )}
                </div>
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
};

export default memo(Stats);
